//state with search data and search manage actions

import axios from 'axios'
// get default data from config file
import configData from '../../config'
// request path
import getSearchPath from './../../scripts/modules/solr-helper'

const dataSearchDefault = configData().params.search.default

const state = {
  // basic search params, used when page is loaded
  searchParams: {
    key: dataSearchDefault.key,
    param: dataSearchDefault.param,
    start: dataSearchDefault.start,
    rows: dataSearchDefault.itemsPerPage,
    sorting: dataSearchDefault.sortOption
  },
  newSearchParams: {
    key: '',
    param: ''
  },
  // basic page params, used when page is loaded
  pageParams: {
    currentPage: dataSearchDefault.pageStart,
    totalPages: 1
  },
  // empty object created for response data
  results: {
    response: {
      docs: {},
      numFound: 0,
      start: 0
    }
  },
  // baisc loading and error state, used when page is loaded
  loading: {
    state: false,
    error: false
  }
  // suggestions: [],
  // activeSuggest: false
}

const getters = {
  GET_SEARCH_PARAMS: state => {
    return state.searchParams
  },
  GET_NEW_SEARCH_PARAMS: state => {
    return state.newSearchParams
  },
  GET_SEARCH_RESULTS_DOCS: state => {
    return state.results.response.docs
  },
  GET_SEARCH_RESULTS_NUM: state => {
    return state.results.response.numFound
  },
  GET_ROWS_NUM: state => {
    return state.searchParams.rows
  },
  GET_TOTAL_PAGES_NUM: state => {
    return state.pageParams.totalPages
  },
  GET_CURRENT_PAGE: state => {
    return state.pageParams.currentPage
  },
  GET_LOADING_STATE: state => {
    return state.loading
  },
  GET_SORTING: state => {
    return state.searchParams.sorting
  }
}

const actions = {
  LOAD_SEARCH_RESULTS: ({ commit }) => {
    let path = getSearchPath()

    if (!state.loading.state) {
      // show loader
      commit('SET_LOADING_STATE', { loadingState: { state: true, error: false} })
    }

    // load search results from path
    axios.get(path).then((response) => {
      commit('SET_RESULTS', { list: response.data })
      commit('SET_ROWS_NUM')
      commit('SET_TOTAL_PAGES_NUM')
      commit('SET_CURRENT_PAGE')
      commit('SET_SORTING')

      // mutatuions in filters module
      commit('SET_FILTERS', { list: response.data.facet_counts })
      commit('SET_FILTER_PARAMS_RES', response.data )

      // facet date ranges
      commit('SET_FACET_DATE_RANGES', response.data.facet_counts.facet_ranges.date)
      commit('SET_DATE_COUNT', response.data.response.numFound)

      // set appIsRunning variable
      commit('SET_APP_IS_RUNNING', true)

      //hide loader
      commit('SET_LOADING_STATE', { loadingState: { state: false, error: false} })
    }, (err) => {
      //hide loader and show error
      commit('SET_LOADING_STATE', { loadingState: { state: false, error: true} })
    })
  },

  LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD: ({ dispatch, commit, rootState }) => {
    let path = getSearchPath()

    // show loader
    commit('SET_LOADING_STATE', { loadingState: { state: true, error: false} })

    // preoloads date start and date end so it can be used in search results load
    // clears from and to values and sets them to default
    axios.get(path).then((response) => {
      commit('SET_DATE_START', response.data )
      commit('SET_DATE_END', response.data )
      commit('SET_DATE_FROM', rootState.dateFilters.dateStart )
      commit('SET_DATE_TO', rootState.dateFilters.dateEnd )
      // set date gap from default start and end date
      commit('SET_DATE_GAP', { start: rootState.dateFilters.dateStart, end: rootState.dateFilters.dateEnd} )
      // fires search results load
      dispatch('LOAD_SEARCH_RESULTS')
    })
  },

  LOAD_SEARCH_RESULTS_WITH_DATA_PRELOAD_ALT: ({ dispatch, commit, rootState }) => {
    let path = getSearchPath()

    // show loader
    commit('SET_LOADING_STATE', { loadingState: { state: true, error: false} })

    // preoloads date start and date end so it can be used in search results load
    // doesnt clear from and to values
    axios.get(path).then((response) => {
      commit('SET_DATE_START', response.data )
      commit('SET_DATE_END', response.data )
      commit('SET_DATE_FROM', rootState.dateFilters.dateRangeSet.from )
      commit('SET_DATE_TO', rootState.dateFilters.dateRangeSet.to )
      // set date gap from default start and end date
      commit('SET_DATE_GAP', { start: rootState.dateFilters.dateRangeSet.from, end: rootState.dateFilters.dateRangeSet.to } )
      // fires search results load
      dispatch('LOAD_SEARCH_RESULTS')
    })
  },

  LOAD_DATE_RANGES: ({ commit, rootState }) => {
    let path = getSearchPath()
    axios.get(path).then((response) => {
      // facet date ranges
      commit('SET_FACET_DATE_RANGES', response.data.facet_counts.facet_ranges.date)
      commit('SET_DATE_COUNT', response.data.response.numFound)
    })
  }
}

const mutations = {
  // update search params in store
  SET_SEARCH_PARAMS: (state, elem) => {
    state.searchParams.key = elem.key
    state.searchParams.param = elem.param
  },
  // update new search params key in store
  SET_NEW_SEARCH_PARAMS_KEY: (state, key) => {
    state.newSearchParams.key = key
  },
  // update new search params key in store
  SET_NEW_SEARCH_PARAMS_PARAM: (state, param) => {
    state.newSearchParams.param = param
  },
  // reset search params key in store
  RESET_SEARCH_PARAMS_KEY: (state) => {
    state.searchParams.key = dataSearchDefault.key
    state.newSearchParams.key = ''
  },
  // reset search params key in store
  RESET_SEARCH_PARAMS_PARAM: (state) => {
    state.searchParams.param = dataSearchDefault.param
    state.newSearchParams.param = dataSearchDefault.param
  },
  // update search start for solr
  SET_NEW_START: (state, n) => {
    state.searchParams.start = (n - 1) * state.searchParams.rows
  },
  // update number of viewed elements on results list (from n or from solr response)
  SET_ROWS_NUM: (state, n) => {
    let rows = n ? n : parseInt(state.results.responseHeader.params.rows)

    state.searchParams.rows = rows
  },
  // set results list from downloaded file
  SET_RESULTS: (state, { list }) => {
    state.results = list
  },
  // set total pages number in results list from sorl response
  SET_TOTAL_PAGES_NUM: (state) => {
    state.pageParams.totalPages = Math.ceil(parseInt(state.results.response.numFound) / state.searchParams.rows)
  },
  // set current results page from given n or from solr response
  SET_CURRENT_PAGE: (state, n) => {
    let currentPage = n ? n : Math.floor(parseInt(state.results.response.start) / state.searchParams.rows) + 1

    state.pageParams.currentPage = currentPage
  },
  // set new sorting param from given
  SET_NEW_SORTING: (state, n) => {
    if (typeof n != typeof undefined) {
      state.searchParams.sorting = n
    } else {
      state.searchParams.sorting = ''
    }
  },
  //set sorting method from solr response
  SET_SORTING: (state) => {
    let sorting = encodeURIComponent(state.results.responseHeader.params.sort)

    if (typeof soritng != typeof undefined) {
      state.searchParams.sorting = sorting
    }
  },
  // set new loading state
  SET_LOADING_STATE: (state, { loadingState }) => {
    state.loading = loadingState
  }
}

export {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js